import React, {FC, useState} from "react"
import PropTypes from "prop-types"

import History from "@irati/utils/history"
import Flex from "@irati/ui/src/Flex"
import {Body, Label} from "@irati/ui/src/Typography"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Button, {IconButton} from "@irati/ui/src/Button"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import adminTracking from "@irati-tracking/admin"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"

import {ADD_PEOPLE_MULTIPLE} from "../../../routes/routeConfig"
import {Action} from "./Steps"
import {StepChip} from "./styled"
import OnboardingFeedbackModal from "./FeedbackModal"

interface Props extends InjectIntl {
  action: Action
  event: string
  index: number
}

const OnboardingStep: FC<Props> = ({event, action, index, formatMessage}, {apps: {HOME, ADMIN}}) => {
  const [isSelected, setIsSelected] = useState<boolean>(false)
  const [modal, setModal] = useState<boolean>(false)

  const {title, subTitle, subTitleLink, button} = action

  const handleActionEvent = () => {
    adminTracking.adminDashboardOnboardingV2Action(event, action?.event || "")
  }

  const handleSlideLink = () => {
    History.push(ADD_PEOPLE_MULTIPLE, ADMIN)
  }

  return (
    <>
      <StepChip key={index} wrap="wrap" width="100%" marginBottom={2}>
        <Flex alignItems="center" width="100%">
          <Icon icon={action.complete ? IconTypes.circleCheckFill : IconTypes.circle} marginRight />
          <Body small weight={!action.complete ? "bold" : "default"} width="90%">
            <FormattedMessage id={title} />
          </Body>
          <IconButton
            inline
            icon={!isSelected ? IconTypes.angleDown : IconTypes.angleUp}
            size={20}
            onClick={() => setIsSelected(!isSelected)}
          />
        </Flex>
        {isSelected && (
          <Flex direction="column" justifyContent="space-between" width="100%" marginTop={1}>
            <Flex direction="column" width="100%">
              <Label>
                {action.subTitleLink ? (
                  <FormattedMessage
                    id={subTitle}
                    values={{
                      link: (
                        <Button small cta onClick={handleSlideLink}>
                          <FormattedMessage id={subTitleLink} />
                        </Button>
                      )
                    }}
                  />
                ) : (
                  <FormattedMessage id={subTitle} />
                )}
              </Label>
              {action.reasons && (
                <Flex justifyContent="flex-start">
                  <Button cta id="adminSection_onboardingFeedback_button" marginTop={2} small onClick={() => setModal(true)}>
                    <FormattedMessage id="admin.components.onboardingProgress.setup.reasonsBtn" />
                  </Button>
                </Flex>
              )}
            </Flex>
            <Flex justifyContent="flex-end" marginTop={3}>
              {action.route ? (
                <ButtonRouterLink small primary onClick={handleActionEvent} to={action.route} app={action.external || ADMIN} marginRight>
                  <FormattedMessage id={button} />
                </ButtonRouterLink>
              ) : (
                <ButtonLink small primary onClick={handleActionEvent} href={formatMessage({id: action.link})} target="_blank">
                  <FormattedMessage id={button} />
                </ButtonLink>
              )}
            </Flex>
          </Flex>
        )}
      </StepChip>
      <OnboardingFeedbackModal show={modal} reasons={action?.reasons || []} sourceEvent={event} onHide={() => setModal(false)} />
    </>
  )
}

OnboardingStep.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default injectIntl(OnboardingStep)
